module.exports = __webpack_public_path__ + "static/img/RAC1610_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC1610_1.png
// module id = 9p8t
// module chunks = 0